import { Injectable } from '@angular/core';
import { DbService } from './db.service';
import { take } from 'rxjs';
import { CommonService } from './common.service';
import { Notification } from '../models/notification.models';
import { PushService } from './push.service';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  constructor(private db: DbService, private commonService: CommonService, private pushService: PushService) {}

  // 공지사항에 대한 내용
  // 새로운 공지사항이 입력이 된다면 pushSwitch가 true인 것만 앱내 알림으로 전송
  noticeSystem(obj) {
    this.db
      .collection$(`members`, ref => ref.where('status', '!=', 'exit').where('pushSwitch', '==', true))
      .pipe(take(1))
      .subscribe(async (datas: any) => {
        if (datas && datas.length > 0) {
          for await (let ele of datas) {
            const id = this.commonService.generateFilename();

            let notification: Notification = {
              id,
              uuid: ele.uuid,
              dateCreated: obj.dateCreated,
              title: obj.title,
              content: obj.content,
              url: obj.url,
              readSwitch: obj.readSwitch,
            };

            await this.db.updateAt(`notifications/${notification.id}`, notification).then(() => {
              if (ele.pushId.length > 0) {
                this.pushService.sendPush(ele.pushId, obj.title, obj.content, {
                  url: obj.url,
                });
              }
            });
          }
        }
      });
  }

  // 한명의 회원의 문의사항 답변
  memberSend(obj) {
    this.db
      .collection$(`members`, ref => ref.where('status', '!=', 'exit').where('pushSwitch', '==', true).where('uuid', '==', obj.uuid))
      .pipe(take(1))
      .subscribe(async (datas: any) => {
        if (datas && datas.length > 0) {
          for await (let ele of datas) {
            await this.db.updateAt(`notifications/${obj.id}`, obj).then(() => {
              if (ele.pushId.length > 0) {
                this.pushService.sendPush(ele.pushId, obj.title, obj.content, {
                  url: obj.url,
                });
              }
            });
          }
        }
      });
  }

  // 회원 푸시알림 전송
  memberPush(obj, uuid) {
    this.db
      .collection$(`members`, ref => ref.where('status', '!=', 'exit').where('pushSwitch', '==', true).where('uuid', '==', uuid))
      .pipe(take(1))
      .subscribe(async (datas: any) => {
        if (datas && datas.length > 0) {
          for await (let ele of datas) {
            const id = this.commonService.generateFilename();

            let notification: Notification = {
              id,
              uuid: ele.uuid,
              dateCreated: new Date().toISOString(),
              title: obj.title,
              content: obj.content,
              url: `alarm-detail?id=${id}`,
              readSwitch: false,
            };
            await this.db.updateAt(`notifications/${notification.id}`, notification).then(() => {
              if (ele.pushId.length > 0) {
                this.pushService.sendPush(ele.pushId, 'Picket', obj.title, {
                  url: notification.url,
                });
              }
            });
          }
        }
      });
  }

  // 아티스트에 대한 정보 push
  async memberArtistPush(obj) {
    this.db
      .collection$(`members`, ref => ref.where('status', '!=', 'exit').where('artistSwitch', '==', true).where('uuid', '==', obj.uuid))
      .pipe(take(1))
      .subscribe(async (datas: any) => {
        if (datas && datas.length > 0) {
          for await (let ele of datas) {
            await this.db.updateAt(`notifications/${obj.id}`, obj).then(() => {
              if (ele.pushId.length > 0) {
                this.pushService.sendPush(ele.pushId, obj.title, obj.content, {
                  url: obj.url,
                });
              }
            });
          }
        }
      });
  }
}
